import { render, staticRenderFns } from "./role-add-edit-flyout.vue?vue&type=template&id=4655db6d&"
import script from "./role-add-edit-flyout.vue?vue&type=script&lang=js&"
export * from "./role-add-edit-flyout.vue?vue&type=script&lang=js&"
import style0 from "./role-add-edit-flyout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports